export enum PaymentsRoles {
  VIEWER = 'roles.paymentsViewer',
  RECORDER = 'roles.paymentsRecorder',
  BULK_RECORDER = 'roles.paymentsBulkRecorder',
}
